import { useContext } from "react"
import { BlogContext, BlogContextType } from "../provider/BlogProvider"
import BlogPostTile from "../../Feed/components/tiles/BlogPostTile"
import Pagination from "../../Common/Pagination/Pagination";

export default function BlogPosts() {
  const { blogPosts, isLoading, totalRecords, currentPage, pageSize, loadItems } = useContext(BlogContext) as BlogContextType;

  if (isLoading) {
    return (
      <div className="blog-post-loader" style={{ display: 'flex', justifyContent: 'center', padding: '4rem 0' }} aria-live="polite" aria-busy="true">
        <i className="fa fa-spinner fa-spin" style={{ fontSize: '2.5rem', color: '#f15a29' }} aria-hidden="true"></i>
        <span className="show-for-sr">Loading posts</span>
      </div>
    );
  }

  return (
    <>
      <div className="grid-x grid-margin-x small-up-1 medium-up-2 large-up-3 blog-post-listing">
        { blogPosts.length > 0 && blogPosts.map((item) => (
          <BlogPostTile key={`blogPost-${item.id}`} node={item} defaultImage={null} />
        ))}
      </div>
      {<Pagination totalRecords={totalRecords} currentPage={currentPage} pageSize={pageSize} onPageChange={loadItems} />}
    </>
  )
}